// 巡检监控
import React, { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import { App, Layout, theme, Space, Button, Card, Segmented, Tooltip, Form, Spin, Row, Col } from 'antd'
import { PauseOutlined, DownloadOutlined, InfoCircleOutlined, BlockOutlined } from '@ant-design/icons';
import { Amap as RMap, config as AmapReactConfig, Marker as AmapMarker, Markers as AmapMarkers, BezierCurve, Scale, TileLayer } from '@amap/amap-react';
import { transformGCJ2WGS, transformWGSGCJ2 } from "@/common/js/common.js" //引入公共方法
import dayjs from 'dayjs';
import { getWebSocketAddress, getAirportNumber, getLiveAddressState } from '@/server/commandFlight.js'
import { distance } from '@/common/js/common.js'

// import './index.less'

import warning from '@/common/img/video/warning.svg';
import map_jc from "@/common/img/command_flight/map_jc.svg" //机场
import map_dd from "@/common/img/command_flight/map_dd.svg" //到达点位
import map_uavJT from "@/common/img/command_flight/map_uavJT.svg" //无人机箭头
import dqszhd from "@/common/img/command_flight/dqszhd.svg" //当前到达航点
import yschdzp from "@/common/img/command_flight/yschdzp.svg" //已经上传的航点照片

import fhgd from "@/common/img/command_flight/head/fhgd.svg" //返航高度
import xy from "@/common/img/command_flight/head/xy.svg" //小雨
import zy from "@/common/img/command_flight/head/zy.svg" //中雨
import dy from "@/common/img/command_flight/head/dy.svg" //大雨
import fs from "@/common/img/command_flight/head/fs.svg" //风速
import wd from "@/common/img/command_flight/head/wd.svg" //温度
import sd from "@/common/img/command_flight/head/sd.svg" //湿度

import cell0 from "@/common/img/command_flight/head/cell0.svg" //4G信号 [0,15)
import cell15 from "@/common/img/command_flight/head/cell15.svg" //4G信号 [15,35)
import cell35 from "@/common/img/command_flight/head/cell35.svg" //4G信号 [35,55)
import cell55 from "@/common/img/command_flight/head/cell55.svg" //4G信号 [55,75)
import cell75 from "@/common/img/command_flight/head/cell75.svg" //4G信号 [75,95)
import cell95 from "@/common/img/command_flight/head/cell95.svg" //4G信号 [95,100)

import dl0 from "@/common/img/command_flight/head/dl0.svg" //电量 [0,25)
import dl25 from "@/common/img/command_flight/head/dl25.svg" //电量 [25,50)
import dl50 from "@/common/img/command_flight/head/dl50.svg" //电量 [50,75)
import dl75 from "@/common/img/command_flight/head/dl75.svg" //电量 [75,100)
import dl100 from "@/common/img/command_flight/head/dl100.svg" //电量 100
import dl_charge from "@/common/img/command_flight/head/dl_charge.svg" //充电中

import sdr0 from "@/common/img/command_flight/head/sdr0.svg" //SDR信号  [0,15)   
import sdr15 from "@/common/img/command_flight/head/sdr15.svg" //SDR信号  [15,35)  
import sdr35 from "@/common/img/command_flight/head/sdr35.svg" //SDR信号  [35,55)  
import sdr55 from "@/common/img/command_flight/head/sdr55.svg" //SDR信号  [55,75)  
import sdr75 from "@/common/img/command_flight/head/sdr75.svg" //SDR信号  [75,95)  
import sdr95 from "@/common/img/command_flight/head/sdr95.svg" //SDR信号  [95,100)

import wifi0 from "@/common/img/command_flight/head/wifi0.svg" //WiFi信号  [0,30)
import wifi30 from "@/common/img/command_flight/head/wifi30.svg" //WiFi信号  [30,60)
import wifi60 from "@/common/img/command_flight/head/wifi60.svg" //WiFi信号  [60,90)
import wifi90 from "@/common/img/command_flight/head/wifi90.svg" //WiFi信号  [90,100)
import wifi_close from "@/common/img/command_flight/head/wifi_close.svg" //WiFi信号 关闭
import wifi_none from "@/common/img/command_flight/head/wifi_none.svg" //WiFi信号  没有网络

import t_wrj from "@/common/img/command_flight/head/t_wrj.svg" //已链接上无人机
import f_wrj from "@/common/img/command_flight/head/f_wrj.svg" //未链接上无人机

import t_jc from "@/common/img/command_flight/head/t_jc.svg" //地图上的机场

import uav_t_p from "@/common/img/command_flight/uav/uav_t_p.svg" //已链接上  状态 p
import uav_f_p from "@/common/img/command_flight/uav/uav_f_p.svg" //未链接上  状态 p
import uav_t_a from "@/common/img/command_flight/uav/uav_t_a.svg" //已链接上  状态 a
import uav_f_a from "@/common/img/command_flight/uav/uav_f_a.svg" //未链接上  状态 a
import uav_t_m from "@/common/img/command_flight/uav/uav_t_m.svg" //已链接上  状态 m
import uav_f_m from "@/common/img/command_flight/uav/uav_f_m.svg" //未链接上  状态 m
import uav_ms from "@/common/img/command_flight/uav/uav_ms.svg" // M/S
import uav_t_dl from "@/common/img/command_flight/uav/uav_t_dl.svg" // 无人机满电池电量
import uav_f_dl from "@/common/img/command_flight/uav/uav_f_dl.svg" // 无人机缺电池电量
import uav_xdqfdgd from "@/common/img/command_flight/uav/uav_xdqfdgd.svg" // 相对起飞高度
import uav_xdjcgd from "@/common/img/command_flight/uav/uav_xdjcgd.svg" // 距离机场距离

import uav_t_ssbz from "@/common/img/command_flight/uav/uav_t_ssbz.svg" //已链接上  上视规避
import uav_f_ssbz from "@/common/img/command_flight/uav/uav_f_ssbz.svg" //未链接上  上视规避

import uav_t_xsbz from "@/common/img/command_flight/uav/uav_t_xsbz.svg" //已链接上  下视规避
import uav_f_xsbz from "@/common/img/command_flight/uav/uav_f_xsbz.svg" //未链接上  下视规避
import uav_t_spbz from "@/common/img/command_flight/uav/uav_t_spbz.svg" //已链接上  水平规避
import uav_f_spbz from "@/common/img/command_flight/uav/uav_f_spbz.svg" //未链接上  水平规避

import rtk from "@/common/img/command_flight/uav/uav_info/rtk.svg" // rtk数量
import gps from "@/common/img/command_flight/uav/uav_info/gps.svg" // gps数量
import dj from "@/common/img/command_flight/uav/uav_info/dj.svg" // 东经
import bw from "@/common/img/command_flight/uav/uav_info/bw.svg" // 北纬
import xdqfgd from "@/common/img/command_flight/uav/uav_info/xdgd.svg" // 相对起飞高度
import hbgd from "@/common/img/command_flight/uav/uav_info/hbgd.svg" // 海拔高度 
import spsd from "@/common/img/command_flight/uav/uav_info/spsd.svg" // 水平速度
import czsd from "@/common/img/command_flight/uav/uav_info/czsd.svg" // 垂直速度
import jcjl from "@/common/img/command_flight/uav/uav_info/jcjl.svg" // 距离机场距离

// import './newGodMap.css'
const { Content } = Layout;
AmapReactConfig.key = '193db6af15a86cd8d48b102ab461b002';

function VideoPatrolMonitor () {
  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState();
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();

  const mapRef = useRef();
  const liveInterval = useRef();//直播计时器
  const islive = useRef(true);//是否开始直播
  const isShowFly = useRef(false)//是否可看

  const ws = useRef(null);
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false)//加载中···

  const [opacity, setOpacity] = useState(true);//切换图层

  const [mapParameters, setMapParameters] = useState({//地图基础参数
    mapZoomScale: 17,//地图缩放比例
    mapScale: 3875.8509003722434,//地图比例尺
    mapDefaultScale: 3875.8509003722434,//默认比例尺
    mapCenterPoint: [104.1866874, 30.8378847],//地图中心点
    liveAddressArr: [],//直播地址
    liveAddressBtn: [],//直播地址按钮
  })

  const [globalStatus, setGlobalStatus] = useState({//全局状态
    isLiveShow: false,//是否展示直播页面
    isPipeline: false,//当前是否存在一条管线
    isExecute: true,//是否 在执行中
    isReturnFlight: false,//是否  返航
    isOpenSeeUAVInfo: false,//是否查看无人机的参数信息
    isOpenSeeAirportInfo: false,//是否查看机场的参数信息
    deviceNumber: '',//设备编号
    title: '',
  })

  const [pipelineAndPoint, setPipelineAndPoint] = useState({//管线及航点坐标
    pipeline: [],//管线坐标
    waypointCoordinates: [],//航点坐标
  })
  const [webSocketList, setWebSocketList] = useState({//从webSocket中获取到的信息
    webSocketUrl: '',//webSocket地址
    airport: {},//机场参数
    UAV: {},//无人机参数 
    typeNum: {//状态码
      title: '',
      files: 0,//文件数目
      linePint: 0,//航点数目
      backHeight: 0,//设置的返航高度
    }
  })

  // 飞行器当前状态
  var status = ["待机", "起飞准备", "起飞准备完毕", "手动飞行", "自动起飞", "航线飞行", "全景拍照", "智能跟随", "ADS-B 躲避", "自动返航", "自动降落", "强制降落", "三桨叶降落", "升级中", "未连接"]

  var dronestatus = [
    '未知',
    '现场调试',
    '远程调试',
    '升级中',
    '待命',
    '准备中',
    '准备完毕',
    '作业中',
    '回收中',
  ];// 无人机当前状态

  const getAirportNumberByToken = async () => {// 进入页面即刻获取状态信息  用以确定是否展示前端页面
    setLoading(true)
    let glo = globalStatus
    let pip = pipelineAndPoint
    let obj = {
      access_token: token,
      CompanyID: localStorage.getItem('dock_CompanyID')
    }
    let res = await getAirportNumber(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      glo.title = res.msg
      setGlobalStatus({ ...glo })
      setLoading(false); return
    }
    // 判断是否存在 管线数据
    if (res.data) {
      // 管线   转84
      let RoutesPoints = []
      res.data.Routes_Points.forEach((res) => {
        let arr = [Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lon).toFixed(7)), Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lat).toFixed(7))];
        // let arr = [res.longitude, res.latitude]
        RoutesPoints.push(arr)
      })
      // 航点   转84
      let InsPoints = []
      res.data.Ins_Points.forEach((res) => {
        let arr = [Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lon).toFixed(7)), Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lat).toFixed(7))];
        // let arr = [res.longitude, res.latitude]
        InsPoints.push(arr)
      })
      pip.pipeline = RoutesPoints
      pip.waypointCoordinates = InsPoints
      setPipelineAndPoint({ ...pip })
      glo.isPipeline = true
      glo.deviceNumber = res.data.dock_info.aircraftSn
      let num = Math.floor(Math.random() * 3)
      setChooseMapKey(num);
      getWebSocket(res.data.dock_info.aircraftSn, InsPoints.length)
    } else {
      glo.isPipeline = false
    }
    setGlobalStatus({ ...glo })
    if (res.data.dock_info.aircraftSn) {
      getLiveState(res.data.dock_info.aircraftSn)
    } else {
      message.warning('暂无机场编号！', 1.5)
    }
    setLoading(false)
  }

  const getLiveState = (aircraftSn) => { //获取直播状态
    liveInterval.current = setTimeout(async () => {
      let res = await getLiveAddressState({ access_token: token, aircraftSn: aircraftSn, camera: 'cam', })
      let map = mapParameters
      if (res.ret !== 200) { message.warning(res.msg || '系统出错了！'); return }
      if (res.data.cam) {
        let arr = []
        map.liveAddressArr = res.data.cam
        res.data.cam.forEach((res, index) => {
          let text = `地址${index + 1}`
          arr.push(text)
        })
        map.liveAddressBtn = arr
        islive.current = false
        setMapParameters({ ...map })
        liveAddress(res.data.cam[0])
        // liveAddress('artc://video.9zhouzhineng.com/dock/drone_01')
        let glo = globalStatus
        glo.isLiveShow = true
        setGlobalStatus({ ...glo })
      }
    }, 5000);
  }

  const getWebSocket = async (aircraftSn, InsPointsLength) => { // 获取 webSocket  地址
    let web = webSocketList
    let res = await getWebSocketAddress({ access_token: token, type: '0' })
    if (res.ret === 200) {
      web.webSocketUrl = res.data
      ws.current = new WebSocket(res.data);

      // 成功获取数据
      ws.current.onmessage = e => {
        try {
          let data = JSON.parse(e.data)
          if (data.msgType === 1213) {
            let obj = {}
            data.mcsParams.map((val, idx) => {
              return obj[val.paramName] = val.paramValue;
            })
            web.typeNum.backHeight = obj.droneReturnHeight
            setWebSocketList({ ...web })
          }

          // 4 为机场
          if (data.msgType === 4) {
            // console.log(`当前机场状态(${data.msgType},mode_code)：`, data.mode_code);
            console.log('机场返回数据', data)
            web.airport = data
            setWebSocketList({ ...web })
            if (data.mode_code === 11) {
              let glo = globalStatus
              glo.title = '无人机任务已结束~'
              setGlobalStatus({ ...glo })
              isShowFly.current = false
            }
            if (data.mode_code !== 65535) { isShowFly.current = true }
            if (data.mode_code === 4) { isShowFly.current = false }
          }
          // 3 为无人机
          if (data.msgType === 3) {
            // console.log(`当前无人机状态(${data.msgType},mode_code)：`, data.mode_code);
            console.log('无人机返回数据', data)
            web.UAV = data
            setWebSocketList({ ...web })

          }

          // 状态码
          if (
            data.msgType === 200
            && data.code !== 3006001
            && data.code !== 3006005
            && data.code !== 3006006
            && data.code !== 3006009
            && data.code !== 3006010
          ) {
            if (data.code === 3005016) {//通过返回航点来前端展示当前所在航点数
              web.typeNum = `${data.details.split('/')[0]}/${InsPointsLength}航点`
            } else {
              web.typeNum.title = data.details
            }
            if (data.code === 3002001) { isShowFly.current = false }

          } else if (data.code === 3006001) {//通过图片上传路径获取当前上传了多少张图片
            web.typeNum.files = data.details.split('_')[4].split('.')[0]
          }

          if (data.msgType === 3202) {
            message.success('飞机正常作业中···')
          }
          if (data.msgType === 3200) {
            message.success('飞机已暂停作业···')
          }
          setWebSocketList({ ...web })
        } catch (error) {
          // message.warning('当前机场状态错误，请确认机场是否正确链接')
          let web = webSocketList
          setWebSocketList({ ...web })
        }
      }


      ws.current.onclose = (msg) => {
        console.log('链接断开', msg);
      };

      ws.current.onopen = (msg) => {
        var data = JSON.stringify({ "id": 1, "msgType": 1212, "deviceNumber": aircraftSn })
        ws.current.send(data);
        console.log("已经发送:1212", msg);
      };

      ws.current.onerror = (msg) => {
        console.log('链接出错', msg);
      }
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
    setWebSocketList({ ...web })
  }

  const liveAddress = async (url) => { //获取直播地址
    document.getElementById('Fplayer').innerHTML = ''
    // 创建阿里云播放器dom
    const Fplayer = document.getElementById('Fplayer')
    const Cplayer = document.createElement('div')
    Fplayer.display = 'none'
    Cplayer.id = 'J_prismPlayer'
    Fplayer.appendChild(Cplayer)
    // let url = 'artc://video.9zhouzhineng.com/dock/drone_01'
    startVideoFun(url)
  }

  const startVideoFun = async (url) => { //开启直播
    console.log('当前的直播地址为：', url);
    let player = new Aliplayer(
      {
        id: `J_prismPlayer`,
        source: url,//视频的播放凭证，可以在通用媒体管理服务控制台获取。
        width: '100%', //容器的大小
        height: '100%',
        format: "video",
        mediaType: "video",
        autoplay: true,
        isLive: true,
        rePlay: true,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        components: [
          { name: 'adComponent', type: staticAdComponent },
        ],
        skinLayout: [
          // 大播放按钮
          // { name: "bigPlayButton", align: "blabs", x: 'calc(50% - 30px)', y: 'calc(50% - 30px)' },
          // 错误提示，当视频播放出错时的提示信息 
          // { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
          // 信息提示，当切换字幕、倍速等设置时，播放器展示的提示信息
          // { name: "infoDisplay" },
          {
            // 控制栏
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // 直播播放时画面上显示LIVE字样
              // { name: "liveDisplay", align: "tlabs", x: 15, y: 6 },
              // 全屏按钮
              // { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
              // 字幕
              // { name: "subtitle", align: "tr", x: 15, y: 12 },
              // 设置
              // { name: "setting", align: "tr", x: 15, y: 12 },
              // 音量
              // { name: "volume", align: "tr", x: 5, y: 10 }
            ]
          }
        ]
      }, (player) => {
        //console.log("播放器创建成功~");
      }
    );
  };

  const staticAdComponent = Aliplayer.Component({ // Aliplayer配置生命周期
    play: () => {
    },
    waiting: () => {
    },
    playing: () => {
      //console.log('正在播放中');
    },
    error: (player, e) => {
      //console.log('error:', e);
    },
    ended: (player, e) => {
      //console.log("直播已结束");
      //console.log("player", player);
      //console.log("e", e);
    }
  })

  const flightControl = () => { // 暂停、继续飞行
    let glo = globalStatus
    let obj = {
      msgType: 0,
      deviceNumber: globalStatus.deviceNumber,
      deviceId: 1,
      params: [],
    }
    // 判断无人机当前飞行状态 上传webSocket

    if (glo.isExecute) {//继续
      obj.msgType = 3202
      //console.log('上传状态', 3202, JSON.stringify(obj));
      ws.current.send(JSON.stringify(obj))
    } else {//暂停
      obj.msgType = 3200
      //console.log('上传状态', 3200, JSON.stringify(obj));
      ws.current.send(JSON.stringify(obj))
    }
  }

  useEffect(() => {
    getAirportNumberByToken()
    return () => {
      if (ws.current) {//如果websoket存在  在切换页面时将其关闭
        ws.current.close()
        ws.current = null
      }
      if (document.getElementById('J_prismPlayer')) { document.getElementById('J_prismPlayer').remove() }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {// 地图比例尺
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    // eslint-disable-next-line
  }, [mapParameters.mapScale])

  return (
    <>
      {/* {console.log('airport', [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(webSocketList.UAV.mode_code) > -1)} */}
      {/* {console.log('UAV', webSocketList.UAV)} */}
      {//是否无人机在执行任务
        isShowFly.current && JSON.stringify(webSocketList.airport) !== '{}' && JSON.stringify(webSocketList.UAV) !== '{}'
          ?
          (
            <div style={{ height: '100vh' }}>
              {/* 地图 */}
              <>
                <RMap
                  features={[]}
                  ref={mapRef}
                  zoom={mapParameters.mapZoomScale}
                  center={mapParameters.mapCenterPoint}
                  onZoomChange={(value) => {
                    let map = { ...mapParameters }
                    map.mapZoomScale = value.getZoom()
                    map.mapScale = value.getScale()
                    setMapParameters({ ...map })
                  }}
                  onClick={(a, value) => { }}
                >
                  {/* 天地图图层 */}
                  <>
                    <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
                    <TileLayer getTileUrl={'http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} opacity={opacity} />
                    <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
                  </>

                  {/* 地图中的机场位置 */}
                  <>
                    {/* 机场 */}
                    <AmapMarker
                      className=''
                      style={{ cursor: 'default' }}
                      visiable="true"
                      draggable={false}
                      position={[Number(webSocketList.airport.longitude || 0), Number(webSocketList.airport.latitude || 0)]}
                      zIndex={99999}
                      offset={[0, 0]}
                    >
                      <img draggable='false'
                        className='pos_abs w17 h17'
                        style={{ top: '-8px', left: '-8px' }}
                        alt='机场'
                        src={map_jc}>
                      </img>
                    </AmapMarker>

                    {/* 航点坐标 map集合 */}
                    <>
                      {
                        pipelineAndPoint.waypointCoordinates.map((res, index) => {
                          return (
                            <AmapMarker
                              key={index}
                              visiable="true"
                              draggable={false}
                              position={res}
                              zIndex={99999}
                              offset={[0, 10]}
                              className=''
                            >
                              <div
                                className='w30 h20 border flex jcc align_center radius4'
                                style={{ backgroundColor: '#FFBD0A' }}
                              >
                                <span className='fs12 fw600 lh18' style={{ color: '#000' }}>{index + 1}</span>
                              </div>
                            </AmapMarker>
                          )
                        })
                      }
                    </>

                    {/* 无人机箭头 */}
                    <AmapMarker
                      visiable="true"
                      draggable={false}
                      position={[webSocketList.UAV.longitude, webSocketList.UAV.latitude]}
                      zIndex={99999}
                      offset={[0, 13]}
                      className=''
                    >
                      <img draggable='false'
                        className=''
                        alt='无人机箭头'
                        src={map_uavJT}
                        style={{ transform: `rotate(${webSocketList.UAV.attitude_head}deg)` }}
                      >
                      </img>
                    </AmapMarker>


                    {/* 管线 */}
                    {
                      (
                        <BezierCurve
                          path={pipelineAndPoint.pipeline}
                          isOutline={true}
                          outlineColor="white"
                          borderWeight={2}
                          strokeColor="#00B5FF"
                          lineJoin="round"
                          lineCap="round"
                          strokeOpacity={1}
                          strokeWeight={4}
                          strokeStyle="solid" // 线样式还支持 'dashed'
                          // strokeStyle是dashed时有效
                          // strokeDasharray={[4, 4]}  //0 设置线段粗细  1 设置线段粗细间隔
                          zIndex={50}
                        />)
                    }
                  </>
                </RMap>
              </>

              {/* 左上角 切换地图图层 */}
              <>
                {
                  <div className="pos_abs  radius8 pointer" style={{ top: '64px', left: '16px', background: '#1F1F1F' }}
                  >
                    {/* <BlockOutlined className="w16 h16 mar12" style={{ color: 'white' }} /> */}
                    <Button icon={<BlockOutlined />} onClick={() => { setOpacity(!opacity) }} />
                  </div>
                }
              </>

              {/* 右下  信息栏  */}
              <>
                <div className='pos_abs pd16 flex_col' style={{ bottom: 0, right: 0, }}>
                  {/* 无人机飞行时的状态 */}
                  <Card className='w280 flex_col' style={{ display: '' }} >
                    {/* 第一级 规避 */}
                    <div className='flex jcsb h50'>
                      {/* 无人机详细信息 */}
                      <div className='pos_rel'>
                        <InfoCircleOutlined
                          onClick={() => {
                            let glo = globalStatus
                            glo.isOpenSeeUAVInfo = !glo.isOpenSeeUAVInfo
                            setGlobalStatus({ ...glo })
                          }}
                        />
                        <div
                          className='pos_abs w328 radius8 pd8'
                          style={{
                            top: '-24px', right: '54px',
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            display: globalStatus.isOpenSeeUAVInfo ? `` : `none`
                          }}>
                          <div>{webSocketList.UAV.deviceId}</div>
                          <Row>
                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={rtk} alt='rtk' />
                              </span>
                              <span>
                                {webSocketList.UAV.position_state.rtk_number}
                              </span>
                            </Col>
                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={gps} alt='gps' />
                              </span>
                              <span>
                                {webSocketList.UAV.position_state.gps_number}
                              </span>
                            </Col>
                            <Col span={6}></Col>

                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={dj} alt='dj' />
                              </span>
                              <span>{webSocketList.UAV.latitude?.toFixed(6)}</span>
                            </Col>
                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={bw} alt='bw' />
                              </span>
                              <span>{webSocketList.UAV.longitude?.toFixed(6)}</span>
                            </Col>
                            <Col span={6}></Col>

                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={xdqfgd} alt='xdqfgd' />
                              </span>
                              <span>{webSocketList.UAV.elevation.toFixed(1)}</span>
                            </Col>
                            {/* 海拔 */}
                            <Col span={9} >
                              <span className="marR8">
                                <img draggable='false' src={hbgd} alt='hbgd' />
                              </span>
                              <span>{webSocketList.UAV.height}</span>
                              {/* <span>N/A</span> */}
                            </Col>
                            <Col span={6}></Col>

                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={spsd} alt='spsd' />
                              </span>
                              <span>{webSocketList.UAV.horizontal_speed.toFixed(1)}</span>
                            </Col>
                            <Col span={9}>
                              <span className="marR8">
                                <img draggable='false' src={czsd} alt='czsd' />
                              </span>
                              <span>{webSocketList.UAV.vertical_speed.toFixed(1)}</span>
                            </Col>
                            <Col span={6}>
                              <span className="marR8">
                                <img draggable='false' src={jcjl} alt='无人机离机场距离' />
                              </span>
                              <span>{webSocketList.UAV.home_distance.toFixed(1)}m</span>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className='flex jcc  align_center'>
                        <Space size={20}>
                          <img draggable='false' src={webSocketList.UAV.obstacle_avoidance.upside ? uav_t_ssbz : uav_f_ssbz} alt='' />
                          <img draggable='false' src={webSocketList.UAV.obstacle_avoidance.horizon ? uav_t_spbz : uav_f_spbz} alt='' />
                          <img draggable='false' src={webSocketList.UAV.obstacle_avoidance.downside ? uav_t_xsbz : uav_f_xsbz} alt='' />
                        </Space>
                      </div>
                    </div>

                    {/* 第二级  速度 */}
                    <div className='flex jcc align_center marTB8 h80'>
                      <div className='fs99 lh80 flex align_center'>
                        <b>
                          {
                            webSocketList.UAV.horizontal_speed
                              ? webSocketList.UAV.horizontal_speed.toFixed(1)
                              : webSocketList.UAV.vertical_speed.toFixed(1)}
                        </b>
                      </div>
                    </div>

                    {/* 第三级 状态电源等 */}
                    <div>
                      {/* 飞行状态、电量 */}
                      <div className='flex jcsb'>
                        <Space>
                          <img draggable='false' src={webSocketList.UAV.mode_code !== 7 ? uav_t_p : uav_f_p} alt='p' />
                          <img draggable='false' src={webSocketList.UAV.mode_code === 7 ? uav_t_a : uav_f_a} alt='a' />
                          <img draggable='false' src={false ? uav_t_m : uav_f_m} alt='m' />
                        </Space>
                        <div className='flex jcc align_center'><img draggable='false' src={uav_ms} alt='uav_ms' /></div>

                        {/* 电量 */}
                        <div className='w67 flex jcr align_center'>
                          <span className='fs20 lh25' style={{ color: webSocketList.UAV.battery.capacity_percent > 30 ? '#25CB55' : '#E50019', opacity: '0.75' }}>
                            <b>{`${webSocketList.UAV.battery.capacity_percent}%`}</b>
                          </span>
                          <img draggable='false' src={webSocketList.UAV.battery.capacity_percent > 30 ? uav_t_dl : uav_f_dl} alt='uav_dl' />
                        </div>
                      </div>

                      {/* 相对高度、距离 */}
                      <div className='flex jcsb marT8 h25'>
                        {/* 相对起飞高度 */}
                        <div className='flex jcc align_center'>
                          <img draggable='false' className='marR4 w16 h25' src={uav_xdqfdgd} alt='uav_xdqfdgd' />
                          <span className=' fs20 lh25'>
                            <b>
                              {`${webSocketList.UAV.height.toFixed(1)}m`}
                            </b>
                          </span>
                        </div>
                        {/* 相对机场距离 */}
                        <div className='flex jcc align_center'>
                          <img draggable='false' className='marR4 lh25' src={uav_xdjcgd} alt='uav_xdjcgd' />
                          <span className='fs20 lh25'>
                            <b>
                              {
                                webSocketList.UAV.longitude && webSocketList.airport.longitude
                                  ? distance([webSocketList.UAV.longitude, webSocketList.UAV.latitude], [webSocketList.airport.longitude, webSocketList.airport.latitude]).toFixed(1)
                                  : 0.0
                              }
                              m
                            </b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Card>

                  {/* 底部按钮 */}
                  <Card className='w280 marT16 none'>
                    <div className='flex' style={{ display: '' }}>
                      {/* 暂停/启动 */}
                      <Button
                        className='wid100 marR8'
                        icon={globalStatus.isExecute ? <PauseOutlined /> : ''}
                        type={'primary'}
                        onClick={() => {
                          let glo = globalStatus
                          glo.isExecute = !globalStatus.isExecute
                          setGlobalStatus({ ...glo })
                          flightControl()
                        }}
                      >
                        {globalStatus.isExecute ? '暂停' : '启动'}
                      </Button>

                      {/* 返航否 */}
                      <Button
                        className='wid100'
                        icon={<DownloadOutlined />}
                        onClick={() => {
                          //console.log('返航');
                        }}
                      >
                        返航
                      </Button>
                    </div>
                  </Card>
                </div>
              </>

              {/* 头部状态栏 */}
              <>
                <div
                  className='pos_abs h40 wid100 pdRL16'
                  style={{ top: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.6),rgba(0,0,0,0))' }}
                >
                  <div className='flex jcsb align_center hei100'>
                    {/* left */}
                    <div>
                      <Space size={12}>
                        {/* 返航高度 */}
                        <span className='flex jcc align_center'>
                          <img draggable='false' alt='返航高度' src={fhgd} />
                          <span style={{ color: colorText }}>{Number(webSocketList.typeNum.backHeight).toFixed(1)}m</span>
                        </span>

                        {/* 雨天 */}
                        <span>
                          <img
                            style={{
                              display: webSocketList.airport.rainfall > 0 &&
                                webSocketList.airport.rainfall < 65535 ? `` : `none`
                            }}
                            draggable='false'
                            alt='天气'
                            src={
                              webSocketList.airport.rainfall === 1
                                ? xy
                                : webSocketList.airport.rainfall === 2
                                  ? zy
                                  : dy
                            }
                          />
                        </span>

                        {/* 风速 */}
                        <span className='flex jcc align_center'>
                          <img draggable='false' alt='风速' src={fs} />
                          <span style={{ color: colorText }}>{webSocketList.airport.wind_speed}m/s</span>
                        </span>

                        {/* 温度 */}
                        <span className='flex jcc align_center'>
                          <img draggable='false' alt='温度' src={wd} />
                          <span style={{ color: colorText }}>{webSocketList.airport.temperature}℃</span>
                        </span>

                        {/* 湿度 */}
                        <span className='flex jcc align_center'>
                          <img draggable='false' alt='湿度' src={sd} />
                          <span style={{ color: colorText }}>{webSocketList.airport.humidity}</span>
                        </span>
                      </Space>
                    </div>

                    {/* right */}
                    <div>
                      <Space size={12}>
                        {/* 无人机是否链接 */}
                        <img
                          draggable='false'
                          alt='无人机'
                          src={webSocketList.airport.mode_code !== 14 ? t_wrj : f_wrj}
                        />
                        {/* 当前网络
                        <img draggable='false'
                          alt='WiFi'
                          src={
                            headStatusBar.wifi === 1
                              ? wifi90
                              : headStatusBar.wifi === 2
                                ? wifi60
                                : headStatusBar.wifi === 3
                                  ? wifi30
                                  : headStatusBar.wifi === 4
                                    ? wifi0
                                    : headStatusBar.wifi === 5
                                      ? wifi_close
                                      : wifi_none
                          }
                        /> */}
                        {/* SDR信号 */}
                        <img draggable='false'
                          alt='SDR'
                          src={
                            webSocketList.airport.sdr_quality < 2
                              ? sdr0
                              : webSocketList.airport.sdr_quality < 4
                                ? sdr15
                                : webSocketList.airport.sdr_quality < 6
                                  ? sdr35
                                  : webSocketList.airport.sdr_quality < 8
                                    ? sdr55
                                    : webSocketList.airport.sdr_quality < 9
                                      ? sdr75
                                      : sdr95
                          }
                        />
                        {/* 4G信号 */}
                        <img draggable='false'
                          alt='4g'
                          src={
                            webSocketList.airport.wireless_link.g4_quality < 2
                              ? cell0
                              : webSocketList.airport.wireless_link.g4_quality < 4
                                ? cell15
                                : webSocketList.airport.wireless_link.g4_quality < 6
                                  ? cell35
                                  : webSocketList.airport.wireless_link.g4_quality < 8
                                    ? cell55
                                    : webSocketList.airport.wireless_link.g4_quality < 9
                                      ? cell75
                                      : cell95

                          }
                        />
                        {/* 当前电量 */}
                        {
                          !webSocketList.airport.drone_charge_state.state
                            ? (
                              <img draggable='false'
                                alt='电量'
                                src={
                                  webSocketList.airport.drone_charge_state.capacity_percent < 11
                                    ? dl0
                                    : webSocketList.airport.drone_charge_state.capacity_percent < 26
                                      ? dl25
                                      : webSocketList.airport.drone_charge_state.capacity_percent < 51
                                        ? dl50
                                        : webSocketList.airport.drone_charge_state.capacity_percent < 76
                                          ? dl75
                                          : webSocketList.airport.drone_charge_state.capacity_percent < 101
                                            ? dl100
                                            : dl_charge
                                }
                              />
                            )
                            : (
                              <img draggable='false'
                                alt='电量'
                                src={dl_charge}
                              />
                            )

                        }

                        {/* 机场信息 */}
                        <img
                          className='pointer'
                          draggable='false'
                          alt='机场'
                          src={t_jc}
                          onClick={() => {
                            let glo = globalStatus
                            glo.isOpenSeeAirportInfo = !globalStatus.isOpenSeeAirportInfo
                            setGlobalStatus({ ...glo })
                          }}
                        />
                      </Space>

                      {/* 机场详细信息 */}
                      <div className='pos_abs pdR16 flex_col' style={{ top: 40, right: 0, }}>
                        <div
                          className='pos_abs w224 radius8 pd8 pos_rel'
                          style={{
                            top: '0', right: '0',
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            display: globalStatus.isOpenSeeAirportInfo ? `` : `none`
                          }}>
                          <div>{globalStatus.deviceNumber || `机场信息`} </div>
                          <Row>
                            <Col span={12} className='flex align_center'>
                              <span className="marR8">
                                <img draggable='false' src={rtk} alt='rtk' />
                              </span>
                              <span>
                                {webSocketList.airport.position_state.rtk_number}
                              </span>
                            </Col>

                            <Col span={12} className='flex align_center'>
                              <span className="marR8">
                                <img draggable='false' src={gps} alt='gps数量' />
                              </span>
                              <span>
                                {webSocketList.airport.position_state.gps_number}
                              </span>
                            </Col>


                            <Col span={12} className='flex align_center'>
                              <span className="marR8">
                                <img className='h20 w20' draggable='false' src={wd} alt='温度' />
                              </span>
                              <span>{webSocketList.airport.environment_temperature}℃</span>
                            </Col>

                            <Col span={12} className='flex align_center'>
                              <span className="marR8 ">
                                <img className='h20 w20' draggable='false' src={sd} alt='湿度' />
                              </span>
                              <span>{webSocketList.airport.humidity}</span>
                            </Col>


                            <Col span={12} className='flex align_center'>
                              <span className="marR8">
                                <img draggable='false' src={dj} alt='东经' />
                              </span>
                              <span>{webSocketList.airport.latitude?.toFixed(6)}</span>
                            </Col>

                            <Col span={12} className='flex align_center'>
                              <span className="marR8">
                                <img draggable='false' src={bw} alt='北纬' />
                              </span>
                              <span>{webSocketList.airport.longitude?.toFixed(6)}</span>
                            </Col>

                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>

              {/* BottomCenter  无人机飞行时的状态 */}
              <>
                {
                  true
                    ?
                    (
                      <div className='pos_abs marB16' style={{ bottom: 0, right: 'calc(50% - 200px)' }}>
                        <Card className='w400'>
                          <div className='flex jcsb align_center'>
                            {/* 正在飞行的无人机状态 */}
                            {/* <div className='fw600 fs20 lh25'>{dronestatus[webSocketList.UAV.uavModeCode]}</div> */}
                            <div className='fw600 fs20 lh25'>{webSocketList.typeNum.title ? webSocketList.typeNum.title : `作业中···`}</div>
                            {/* 当前航点及已上传航点 */}
                            <div className='flex jcsb fw500 fs20 lh25' >
                              <div className='flex align_center pdR8'>
                                <img className='pdR4' src={dqszhd} alt='总航点数' />
                                <span>{pipelineAndPoint.waypointCoordinates.length}</span>
                              </div>

                              <div className='flex align_center'>
                                <img className='pdR4' src={yschdzp} alt='已经上传的航点照片' />
                                <span>{webSocketList.typeNum.files}</span>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    )
                    : ''
                }
              </>
            </div >
          )
          :
          (
            <Spin spinning={loading}>
              {/* 错误提示框 */}
              <div className='flex_col jcc align_center' style={{ height: 'calc(100vh - 224px)', width: 'calc(100vw - 297px)', }}>
                <div className='marB24'>
                  <img src={warning} alt='warning' />
                </div>
                {/* 提示文字 */}
                <div className='marB24 flex_col jcc'>
                  <span className='fw400 fs24 lh32'>{globalStatus.title || `请确认无人机是否启动了管线巡检航线的执行任务`}</span>
                  {/* <span className='fw400 fs14 lh22 tc opa45'>error_code:4009 请求数据错误，测网络情况或播放地址是否可以访问。 </span> */}
                </div>
                {/* 底部按钮 */}
                <div>
                  <Space>
                    <Button onClick={() => { getAirportNumberByToken() }}>Try Again</Button>
                  </Space>
                </div>
              </div>
            </Spin>
          )
      }
      {/* 左下角  视频栏 */}
      <>
        {
          (
            <div
              className='pos_abs pd16'
              style={{
                bottom: 0, left: 0,
                display: isShowFly.current && JSON.stringify(webSocketList.airport) !== '{}' && JSON.stringify(webSocketList.UAV) !== '{}' ? `` : `none`
              }}>
              <Segmented
                style={{
                  display: isShowFly.current && JSON.stringify(webSocketList.airport) !== '{}' && JSON.stringify(webSocketList.UAV) !== '{}' ? `` : `none`
                }}
                className=''
                defaultValue='地址1'
                options={mapParameters.liveAddressBtn}
                onChange={(e) => {
                  if (e === '地址1') { liveAddress(mapParameters.liveAddressArr[0]) }
                  if (e === '地址2') { liveAddress(mapParameters.liveAddressArr[1]) }
                }}
              />
              {/* 视频播放器 容器 */}
              <div className='w280 h158 marT8 radius8 hidden'>
                <div id='Fplayer' className='wid100 hei100'></div>
              </div>
            </div>
          )
        }
      </>
    </>
  )
}
export default VideoPatrolMonitor;